<script>
/**
 * button组件，根据props确定显示样式，可点击时在点击时触发click事件
 *
 *
 */
import sizeMixin from "../../../utils/sizeMixin";
import iconMixin from "../../../utils/iconMixin";
export default {
  name: "SjButton",
  mixins: [sizeMixin, iconMixin],
  props: {
    type: {
      type: String,
      default: "btn" //btn iconBtn text
    },
    theme: {
      type: String,
      default: "1",
      validator: val => ["1", "2", "3", "4"].includes(val)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    width: {
      type: String
    }
  },
  /**
   * render函数，通过props属性挂载class确定样式
   */
  render() {
    const {
      $slots,
      disabled,
      loading,
      size,
      border,
      type,
      iconClass,
      width,
      fontFamily,
      theme
    } = this;
    if (type === "btn") {
      return (
        <div
          class={[
            "sj-button",
            { disabled, loading, border },
            size,
            `theme-${theme}`
          ]}
          style={{ width: `${width}px` }}
          onClick={() => {
            if (!disabled && !loading) {
              this.$emit("click");
            }
          }}
        >
          {!loading ? (
            $slots.default
          ) : (
            <div class="loading-bubbles">
              {Array(3).fill(
                <div class="bubble-container">
                  <div class="bubble" />
                </div>
              )}
            </div>
          )}
        </div>
      );
    } else if (type === "iconBtn") {
      return (
        <div
          style={{ width: `${width}px` }}
          class={[
            "sj-button-icon",
            { border, disabled },
            size,
            `theme-${theme}`
          ]}
          onClick={() => {
            if (!disabled) {
              this.$emit("click");
            }
          }}
        >
          {
            <div class="sj-button-icon-box">
              <div class={["icon-box", size]}>
                <i class={[fontFamily, iconClass, size]} />
              </div>
              <div>{$slots.default}</div>
            </div>
          }
        </div>
      );
    } else {
      return (
        <div
          class={["sj-button-text", { disabled }, size]}
          onClick={() => {
            if (!disabled) {
              this.$emit("click");
            }
          }}
        >
          {$slots.default}
        </div>
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "./index.less";

@bubble-size: 10px;
@theme: 1, 2, 3, 4;
@icon-theme: 1, 2;
.sj-button {
  &.large {
    height: @large-size;
    padding: 0 4px;
    each(@theme, {
      &.theme-@{value} {
        .button("theme-@{value}", "large");
      }
    })
  }
  &.middle {
    height: @middle-size;
    padding: 0 4px;
    each(@theme, {
      &.theme-@{value} {
        .button("theme-@{value}", "middle");
      }
    })
  }
  &.default {
    height: @default-size;
    padding: 0 4px;
    each(@theme, {
      &.theme-@{value} {
        .button("theme-@{value}", "default");
      }
    })
  }
  &.small {
    height: @small-size;
    padding: 0 4px;
    each(@theme, {
      &.theme-@{value} {
        .button("theme-@{value}", "small");
      }
    })
    .loading-bubbles {
      transform: scale(30/40);
    }
  }
  &.mini {
    height: @mini-size;
    padding: 0 4px;
    each(@theme, {
      &.theme-@{value} {
        .button("theme-@{value}", "mini");
      }
    })
    .loading-bubbles {
      transform: scale(30/40);
    }
  }
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: @base-border-radius;
  cursor: pointer;

  .loading-bubbles {
    transform-origin: center;
    white-space: nowrap;
    .bubble-container {
      display: inline-block;
      width: @bubble-size;
      height: @bubble-size;
      margin: 0 4px;
      .bubble {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        transform-origin: 50% 50%;
        animation: bubble 1.2s -0.6s infinite ease-out;
      }
      &:nth-of-type(2n) {
        .bubble {
          animation-delay: -0.3s;
        }
      }
      &:nth-of-type(3n) {
        .bubble {
          animation-delay: 0s;
        }
      }
    }
  }

  @keyframes bubble {
    0%,
    100% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
  }
}

.sj-button-icon {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: @base-border-radius;
  cursor: pointer;
  &.large {
    each(@icon-theme, {
      &.theme-@{value} {
        .button-icon("no-border-icon", "large", "theme-@{value}");
        &.border {
          .button-icon("border-icon", "large", "theme-@{value}");
        }
      }
    })
  }
  &.middle {
    each(@icon-theme, {
      &.theme-@{value} {
        .button-icon("no-border-icon", "middle", "theme-@{value}");

        &.border {
          .button-icon("border-icon", "middle", "theme-@{value}");
        }
      }
    })
  }
  &.default {
    each(@icon-theme, {
      &.theme-@{value} {
        .button-icon("no-border-icon", "default", "theme-@{value}");
        &.border {
          .button-icon("border-icon", "default", "theme-@{value}");
        }
      }
    })
  }
  &.small {
    each(@icon-theme, {
      &.theme-@{value} {
        .button-icon("no-border-icon", "small", "theme-@{value}");
        &.border {
          .button-icon("border-icon", "small", "theme-@{value}");
        }
      }
    })
  }
  &.mini {
    each(@icon-theme, {
      &.theme-@{value} {
        .button-icon("no-border-icon", "mini", "theme-@{value}");
        &.border {
          .button-icon("border-icon", "mini", "theme-@{value}");
        }
      }
    })
  }
  .sj-button-icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-box {
      text-align: center;
      margin-right: 5px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      & .mini,
      & .small,
      & .default {
        font-size: 16px !important;
      }
      & .large,
      & .middle {
        font-size: 20px !important;
      }
    }
  }
}

.sj-button-text {
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  &.middle {
    .button-text("text-middle");
  }
  &.large {
    .button-text("text-large");
  }
  &.default {
    .button-text("text-default");
  }
  &.small {
    .button-text("text-small");
  }
  &.mini {
    .button-text("text-mini");
  }
}
</style>
